export type NoticeType = 'tick' | 'permission' | 'message' | 'duplicate_tab'

export interface NoticeInfo {
    uids: string[]
    type: NoticeType
    info?: Record<string, unknown>
}

type NoticeChangeListener = (noticeInfo: NoticeInfo) => void
const noticeChangeListeners = new Set<NoticeChangeListener>()

/**
 * 注册通知变化监听器
 */
export function onNoticeChange(listener: NoticeChangeListener) {
    noticeChangeListeners.add(listener)
    return () => noticeChangeListeners.delete(listener)
}

/**
 * 触发通知变化广播
 */
export function notifyNoticeChange(noticeInfo: NoticeInfo) {
    noticeChangeListeners.forEach(listener => listener(noticeInfo))
}

/**
 * 本地模拟发送测试通知
 */
export function sendTestNotice() {
    notifyNoticeChange({
        type: 'tick',
        uids: ["412456608"], // 空数组表示全局广播，这里写死测试 ID
        info: { message: 'Hello, 这是一个基于新版 Stateless 架构的测试消息!' }
    });
}

